<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn flat icon color="darkGreen" @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <div v-if="selectedFile" style="height: 100%;">
                    <iframe
                        :src="`${serverUrl}/compliance-upload/stream-file/${selectedFile}`"
                        type="application/pdf"
                        width="100%"
                        height="100%"
                        style="border: none;"
                    ></iframe>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Close" variant="outlined" elevation="1" @click="dialog = false"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,

            serverUrl: process.env.VUE_APP_SERVER_URL,
            selectedFile: null,
        }
    },
    methods: {
        viewFile(data){
            this.dialog = true
            this.dialog_title = 'View File'
            this.dialog_sub_title = data
            this.selectedFile = data
        }
    }
})
</script>

<style scoped>

</style>